<!-- eslint-disable vue/valid-template-root -->
<template>
  <v-card class="rounded-lg">
    <v-card-title>
      <v-row>
        <v-col cols="3"
          ><v-img :src="integration.image" max-width="60"></v-img
        ></v-col>
        <v-col
          cols="6"
          class="d-flex flex-row align-center justify-center pl-0"
        >
          <v-row no-gutters>
            <v-col cols="12">
              <span class="text-subtitle-1">{{ integration.title }}</span>
            </v-col>
            <v-col cols="12">
              <v-chip x-small class="mt-n3">
                {{ $t("registrations.integrations.data") }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row class="min-description-height">
        <v-col>
          <span class="text-caption">
            {{ integration.description }}
          </span>
          <br />
        </v-col>
      </v-row>
      <v-row>
        <v-divider class="mx-3"></v-divider>
      </v-row>
      <v-row>
        <v-col cols="6" class="d-flex align-center">
          <span class="text-caption">
            {{ $t("registrations.integrations.integration") }}
            <br />
            <b>ElevenTickets </b>
          </span>
          <v-tooltip max-width="350" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="d-flex align-center pl-2">
                <InfoIcon size="small" />
              </span>
            </template>
            <span>
              {{ $t("registrations.integrations.card-info") }}
            </span>
          </v-tooltip>
        </v-col>
        <v-col cols="6" class="d-flex flex-row justify-end">
          <v-chip v-if="comingSoon">
            {{ $t("registrations.integrations.coming-soon") }}
          </v-chip>
          <v-btn
            v-else
            @click="openDialog()"
            outlined
            height="34"
            class="rounded-lg"
          >
            {{ $t("registrations.integrations.connect") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import InfoIcon from "@/components/icons/InfoIcon.vue";

export default {
  name: "IntegrationCard",
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  components: {
    InfoIcon,
  },
  computed: {
    comingSoon() {
      return (
        this.integration.integration == "googleAds" ||
        this.integration.integration == "googleTagManager"
      );
    },
  },
  methods: {
    openDialog() {
      const { integration } = this;
      this.$emit("open-dialog", integration);
    },
  },
};
</script>

<style scoped>
.min-description-height {
  min-height: 90px !important;
}
</style>
